module.exports = __webpack_public_path__ + "static/img/ubereats_gestion.b706ed6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ubereats_gestion.png
// module id = Xfsw
// module chunks = 4